import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField, MenuItem, Select } from "@mui/material";
import { Navigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddCourse extends Component {
  state = {
    course_name: "",
    meta_keys: "",
    level_id: "",
    description: "",
    specification: "",
    selectedImage: null,
    img_alt_text: "",
    meta_description: "",
    levels: [],
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getLevels();
  }

  // 🔥 Get Levels (limit 100)
  getLevels = async () => {
    try {
      if (init() === "success") {
        const resp = await axios.post(Constants.getUrls.getAllLevels, {
          page: 1,
          limit: 100,
        });

        this.setState({
          levels: resp.data.data.rows || [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  handleSpecification = (content) => {
    this.setState({ specification: content });
  };

  // 🔥 Submit
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      course_name,
      meta_keys,
      level_id,
      description,
      specification,
      selectedImage,
      meta_description,
      img_alt_text
    } = this.state;

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      course_name,
      meta_keys,
      level_id,
      image_id: selectedImage.id,
      description,
      specification,
      role_id: 1, // ✅ default
      meta_description,
      img_alt_text
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(
          Constants.postUrls.createCourses,
          payload,
        );

        this.setState({
          notification: true,
          message: resp.data.message || "Created successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      }
    } catch (err) {
      console.log(err);
      
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/courses" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Create Course
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Course Name */}
                  <Grid item sm={6}>
                    <TextField
                      label="Course Name"
                      name="course_name"
                      value={this.state.course_name}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Level Dropdown */}
                  <Grid item sm={6}>
                    <label style={{color: "#fff", fontSize: "14px"}}>Select Level</label>
                    <Select
                      value={this.state.level_id}
                      
                      name="level_id"
                      label="Select Level"
                      // style={{
                      //   height: "45px",
                      // }} 
                      required
                      onChange={(e)=>{ this.setState({level_id: e.target.value})}}
                      style={{ width: "100%", height: "45px", color: "#fff" }}
                    >
                      <MenuItem value="">Select Level</MenuItem>
                      {this.state.levels.map((lvl) => (
                        <MenuItem key={lvl.id} value={lvl.id}>
                          {lvl.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {/* Image Picker */}
                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Select Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                        }}
                      />
                    )}
                  </Grid>

                   <Grid item sm={6}>
                                      <TextField
                                        label="Image Text"
                                        name="img_alt_text"
                                        value={this.state.img_alt_text}
                                        onChange={this.handleInput}
                                        fullWidth
                                      />
                                    </Grid>
                                    <Grid item sm={12}>
                                      <TextField
                                        label="Meta Keys"
                                        name="meta_keys"
                                        value={this.state.meta_keys}
                                        onChange={this.handleInput}
                                        fullWidth
                                      />
                                    </Grid>
                  
                                    <Grid item sm={12}>
                                      <TextField
                                        label="Meta Description"
                                        name="meta_description"
                                        multiline
                                        rows={4}
                                        value={this.state.meta_description}
                                        onChange={this.handleInput}
                                        fullWidth
                                      />
                                    </Grid>

                  {/* Description */}
                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      multiline
                      rows={4}
                      value={this.state.description}
                      onChange={this.handleDescription}
                      fullWidth
                    />
                  </Grid>

                  {/* Specification */}
                  <Grid item sm={12}>
                    <SunEditor
                      height={150}
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["paragraphStyle", "blockquote"],
                          [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "subscript",
                            "superscript",
                          ],
                          ["fontColor", "hiliteColor"],
                          ["align", "list", "lineHeight"],
                          ["outdent", "indent"],

                          ["table", "horizontalRule", "link", "image", "video"],
                          // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                          ["imageGallery"], // You must add the "imageGalleryUrl".
                          // ["fullScreen", "showBlocks", "codeView"],
                          ["preview", "print"],
                          ["removeFormat"],

                          // ["save", "template"],
                          // '/', Line break
                        ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                        defaultTag: "div",
                        height: 120,
                        showPathLabel: false,
                        // font: sortedFontOptions
                      }}
                      setContents={this.state.specification}
                      onChange={this.handleSpecification}
                    />
                  </Grid>
                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create Course"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            {/* Snackbar */}
            <MDSnackbar
              color="success"
              title="Course"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* Media Modal */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
